import { render, staticRenderFns } from "./RegentsView.vue?vue&type=template&id=32304f8f&scoped=true&"
import script from "./RegentsView.vue?vue&type=script&lang=ts&"
export * from "./RegentsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32304f8f",
  null
  
)

export default component.exports